import React from "react"
import {icons} from "library-react/res"
import Generator from "library-js/utils/Generator";

export default function (Components) {
	const {Svg, Path, Polygon, G, Circle, RadialGradient, Defs, Stop} = Components;

	return {
		...icons(Components),

		logo: (color) => (
			<Svg viewBox="0 0 43 48">
				<Polygon
					fill={color}
					points="32.4749177 0.000205714286 28.2553694 2.36386286 33.8058371 4.60957714"/>
				<Path
					fill={color}
					d="M24.7333226,5.55819429 C26.0004355,6.02448 27.1808548,6.59225143 28.2565484,7.20733714 C35.3238065,10.1991086 40.3409355,17.7399086 40.3409355,26.5753371 C40.3409355,31.1483657 38.9184677,35.3785371 36.5465323,38.8153371 C36.8308871,37.6763657 36.9009355,36.4797943 36.7393387,35.2221943 C36.2434516,31.8107657 34.8820161,29.2242514 32.6550323,27.4619657 C31.2720968,26.3675657 28.3855484,24.7136229 23.9946935,22.4994514 C19.6031452,20.2839086 16.9579516,18.89328 16.0605,18.32688 C14.0929032,17.1056229 12.8701774,15.7485943 12.3902419,14.2571657 C11.9359677,12.8439086 11.8021129,11.7385371 11.9907581,10.9431086 C12.1787097,10.1483657 12.720371,9.49830857 13.6164355,8.98950857 C14.5208226,8.50676571 15.4480968,8.18722286 16.3996452,8.02882286 C17.0827903,7.92802286 17.6723065,7.93419429 18.1661129,8.04802286 C18.6606129,8.16116571 19.0594032,8.39705143 19.3604032,8.75499429 C19.6614032,9.11225143 19.8923548,9.47225143 20.0504839,9.83293714 C20.2093065,10.1929371 20.3799194,10.65648 20.5609355,11.2215086 L22.2476452,16.4665371 L29.6970484,14.1241371 C28.3501774,10.5570514 26.7737419,8.23590857 24.9677419,7.16139429 C23.9364355,6.53739429 22.7802903,6.13693714 21.4986129,5.95933714 C20.3147258,5.71796571 19.178,5.69739429 18.2874839,5.74539429 C17.3969677,5.79408 15.6804355,6.07453714 14.5437097,6.45853714 C6.08380645,9.31728 0,17.2427657 0,26.5753371 C0,37.13808 7.79340323,45.8967086 18.0038226,47.5485943 C14.8800806,46.5200229 12.2376613,44.8434514 10.3331774,43.2855086 C10.2395484,43.2087086 10.1466129,43.1305371 10.054371,43.0523657 C9.89762903,42.9200229 9.74574194,42.7890514 9.60009677,42.6594514 C9.5675,42.6299657 9.53351613,42.6018514 9.50091935,42.5723657 C8.65687097,41.8125943 8.01048387,41.1145371 7.59643548,40.5776229 C7.59435484,40.57488 7.59296774,40.5728229 7.5908871,40.5693943 C4.52748387,36.8802514 2.65837097,31.96848 2.65837097,26.5753371 C2.65837097,22.1120229 3.94143548,17.9805943 6.11917742,14.5965943 C5.96104839,15.62448 5.97491935,16.6441371 6.18090323,17.6528229 C6.54640323,19.32048 7.26422581,20.8434514 8.33645161,22.2189943 C9.40798387,23.5945371 11.1432419,24.9385371 13.5415323,26.2509943 C14.3460484,26.7069943 15.8579839,27.4914514 18.0773387,28.6057371 C20.2966935,29.7193371 22.1581774,30.7259657 23.6652581,31.6249371 C25.1709516,32.5245943 26.4436129,33.4338514 27.4839355,34.3527086 C28.7871129,35.5568229 29.7102258,37.0496229 30.2553548,38.8311086 C30.758871,40.4857371 30.7692742,41.8125943 30.2900323,42.81168 C30.2012581,42.9824229 30.1013871,43.1408229 29.9918065,43.2875657 C29.8822258,43.4363657 29.7726452,43.5625371 29.6630645,43.6674514 C29.5527903,43.7723657 29.4092258,43.8813943 29.2316774,43.9938514 C29.0527419,44.1069943 28.9154194,44.1927086 28.8204032,44.2496229 C28.724,44.30928 28.5617097,44.38128 28.3314516,44.46768 C28.1025806,44.5547657 27.9541613,44.6075657 27.8889677,44.6281371 C27.8237742,44.6493943 27.6746613,44.6960229 27.4402419,44.7693943 C27.2072097,44.8427657 27.076129,44.8832229 27.0504677,44.8914514 C26.0621613,45.20208 25.2035484,45.2041371 24.474629,44.89488 C23.8566774,44.66448 23.3288871,43.8683657 22.8905645,42.5058514 L20.6954839,35.6795657 L11.9200161,38.4381943 C12.7765484,41.3682514 14.3273226,43.6544229 16.5730323,45.2973943 C17.6584355,46.0893943 20.3070968,47.2784229 25.1293387,46.8738514 C31.003,46.3815086 34.1919355,43.7037943 35.2856613,42.8843657 C39.9990161,38.9847086 42.9993065,33.1273371 42.9993065,26.5753371 C42.9993065,15.92208 35.0734355,7.10036571 24.7333226,5.55819429"/>
			</Svg>
		),

		menu: color => (
			<Svg viewBox="0 0 28 18">
				<Path fill={color}
					  d="M16 18H1a1 1 0 1 1 0-2h15a1 1 0 1 1 0 2zm11-8H1a1 1 0 1 1 0-2h26a1 1 0 1 1 0 2zm0-8H1a1 1 0 1 1 0-2h26a1 1 0 1 1 0 2z"
				/>
			</Svg>
		),

		account: color => (
			<Svg fill={color} viewBox="0 0 23.39 23.306">
				<Path
					d="M11.699 1.313A5.981 5.981 0 1 1 5.716 7.3 5.981 5.981 0 0 1 11.7 1.318m0-1.313a7.294 7.294 0 1 0 7.294 7.294A7.294 7.294 0 0 0 11.699 0z"/>

				<Path
					d="M1.38 23.306a9.615 9.615 0 0 1 1.163-1.85c2.034-2.593 5.11-3.892 9.157-3.892 6.466 0 9.2 3.531 10.308 5.73h1.382c-1.12-2.572-4.119-6.943-11.69-6.943S1.11 20.723 0 23.306z"/>
			</Svg>
		),

		basket: color => (
			<Svg fill={color} viewBox="0 0 22.525 22.596">
				<Path
					d="M21.495 8.428v13.137H1.03V8.428h20.465m.114-1.03H.916A.916.916 0 0 0 0 8.314v13.364a.916.916 0 0 0 .916.916h20.693a.916.916 0 0 0 .916-.916V8.314a.916.916 0 0 0-.916-.916z"
				/>

				<Path
					d="M11.263 0c-3.708 0-6.7 4.455-6.7 9.951q0 .506.034 1h1.032c-.023-.33-.037-.664-.037-1a11.651 11.651 0 0 1 1.788-6.46 4.842 4.842 0 0 1 3.883-2.461 4.862 4.862 0 0 1 3.892 2.461 11.732 11.732 0 0 1 1.785 6.46c0 .337-.014.671-.037 1h1.037q.034-.494.034-1C17.965 4.455 14.964 0 11.263 0z"
				/>
			</Svg>
		),

		search: (color) => (
			<Svg viewBox="0 0 21.494 21.494">
				<Path
					fill={color}
					d="M21.494 20.544L14.21 13.26a8.079 8.079 0 1 0-.95.95l7.285 7.285zM8.06 14.777a6.717 6.717 0 1 1 6.717-6.717 6.725 6.725 0 0 1-6.717 6.717z"/>
			</Svg>
		),

		delete: (color) => (
			<Svg viewBox="0 0 16.829 18.563" fill={color}>
				<Path
					d="M222.884 154.7a.462.462 0 0 0-.485.435v8.216a.488.488 0 0 0 .971 0v-8.216a.462.462 0 0 0-.486-.435zm0 0"
					transform="translate(-211.609 -147.979)"/>
				<Path
					d="M104.884 154.7a.462.462 0 0 0-.485.435v8.216a.488.488 0 0 0 .971 0v-8.216a.462.462 0 0 0-.486-.435zm0 0"
					transform="translate(-99.335 -147.979)"/>
				<Path
					d="M1.375 5.525v10.711a2.266 2.266 0 0 0 .712 1.654 2.529 2.529 0 0 0 1.734.672H13a2.528 2.528 0 0 0 1.734-.672 2.266 2.266 0 0 0 .712-1.654V5.525a1.675 1.675 0 0 0 1.363-1.82 1.8 1.8 0 0 0-1.838-1.446h-2.483v-.543A1.622 1.622 0 0 0 11.928.5a2.026 2.026 0 0 0-1.362-.5H6.257A2.026 2.026 0 0 0 4.9.5a1.622 1.622 0 0 0-.56 1.219v.543H1.851A1.8 1.8 0 0 0 .013 3.705a1.675 1.675 0 0 0 1.362 1.82zM13 17.692H3.821a1.448 1.448 0 0 1-1.475-1.456V5.563h12.131v10.673A1.448 1.448 0 0 1 13 17.692zM5.306 1.716a.794.794 0 0 1 .275-.6.994.994 0 0 1 .676-.248h4.309a.994.994 0 0 1 .676.244.794.794 0 0 1 .275.6v.543H5.306zM1.851 3.129h13.121a.832.832 0 0 1 .873.782.832.832 0 0 1-.873.782H1.851a.832.832 0 0 1-.873-.782.832.832 0 0 1 .873-.782zm0 0"
				/>
				<Path
					d="M163.884 154.7a.462.462 0 0 0-.485.435v8.216a.488.488 0 0 0 .971 0v-8.216a.462.462 0 0 0-.486-.435zm0 0"
					transform="translate(-155.472 -147.979)"/>
			</Svg>
		),

		creditCard: (colored) => {
			const disabledColor = "#34495e";
			const color = [
				"#e7e8e3",
				"#34495e",
				"#fff", "",
				"#202121",
				colored ? "#ea001b" : disabledColor,
				colored ? "#f79f1a" : disabledColor,
				colored ? "#ff5f01" : disabledColor,
			];

			return (
				<Svg viewBox="0 0 30.632 21.425">
					<G transform="translate(0 -76.943)">
						<Path
							d="M37.748 103.731a1.754 1.754 0 0 1-1.753 1.754H9.837a1.754 1.754 0 0 1-1.753-1.754v-16.95a1.753 1.753 0 0 1 1.753-1.754h26.158a1.754 1.754 0 0 1 1.753 1.754v16.951z"
							fill={color[0]} transform="translate(-7.6 -7.6)"/>
						<Path d="M0 0h29.664v4.172H0z" fill={color[1]} transform="translate(.483 81.406)"/>
						<Path d="M0 0h29.664v2.582H0z" fill={color[2]} transform="translate(.483 85.579)"/>
						<G opacity={.15} transform="translate(.484 77.427)">
							<Path
								d="M9.331 103.731v-16.95a1.754 1.754 0 0 1 1.754-1.754H9.837a1.754 1.754 0 0 0-1.753 1.754v16.951a1.754 1.754 0 0 0 1.753 1.754h1.247a1.754 1.754 0 0 1-1.753-1.755z"
								fill={color[4]} transform="translate(-8.084 -85.027)"/>
						</G>
						<Path
							d="M316.353 301.7a2.767 2.767 0 0 1 1.028-2.155 2.773 2.773 0 1 0 0 4.31 2.767 2.767 0 0 1-1.028-2.155z"
							fill={color[5]} transform="translate(-294.145 -208.705)"/>
						<Path
							d="M390.127 298.928a2.761 2.761 0 0 0-1.745.618 2.773 2.773 0 0 1 0 4.31 2.773 2.773 0 1 0 1.745-4.928z"
							fill={color[6]} transform="translate(-365.146 -208.704)"/>
						<Path d="M373.256 311.416a1.323 1.323 0 1 0-1.028 2.155 2.767 2.767 0 0 0 1.028-2.155z"
							  fill={color[7]} transform="translate(-348.992 -218.419)"/>
						<G transform="translate(0 76.943)">
							<Path
								d="M308.036 297.358a3.257 3.257 0 1 1 2.05-5.787.484.484 0 0 1 0 .751 2.289 2.289 0 0 0 0 3.559.484.484 0 0 1 0 .751 3.264 3.264 0 0 1-2.05.726zm0-5.546a2.289 2.289 0 1 0 0 4.579 2.268 2.268 0 0 0 .977-.218 3.259 3.259 0 0 1 0-4.144 2.269 2.269 0 0 0-.977-.217z"
								fill={color[4]} transform="translate(-286.545 -278.048)"/>
							<Path
								d="M382.527 297.358a3.264 3.264 0 0 1-2.05-.726.484.484 0 0 1 0-.751 2.289 2.289 0 0 0 0-3.558.484.484 0 0 1 0-.751 3.257 3.257 0 1 1 2.05 5.787zm-.977-1.185a2.289 2.289 0 1 0 0-4.144 3.259 3.259 0 0 1 0 4.144z"
								fill={color[4]} transform="translate(-357.546 -278.048)"/>
							<Path
								d="M364.628 306.454a.483.483 0 0 1-.3-.108 3.256 3.256 0 0 1 0-5.061.484.484 0 0 1 .609 0 3.256 3.256 0 0 1 0 5.061.483.483 0 0 1-.309.108zm0-4.121a2.29 2.29 0 1 0 .544 1.482 2.279 2.279 0 0 0-.544-1.482z"
								fill={color[4]} transform="translate(-341.392 -287.762)"/>
							<Path
								d="M30.148 80.321a.484.484 0 0 0 .484-.484v-.657a2.24 2.24 0 0 0-2.237-2.237H2.237A2.24 2.24 0 0 0 0 79.18v16.951a2.24 2.24 0 0 0 2.237 2.237h26.157a2.24 2.24 0 0 0 2.237-2.237V81.406a.484.484 0 0 0-.484-.484H.967V79.18a1.271 1.271 0 0 1 1.27-1.27h26.157a1.271 1.271 0 0 1 1.27 1.27v.657a.484.484 0 0 0 .484.484zm-.484 7.356H.967v-1.615h28.7v1.614zm-1.27 9.723H2.237a1.271 1.271 0 0 1-1.27-1.27v-7.486h28.7v7.487a1.271 1.271 0 0 1-1.273 1.269zm1.27-15.511V85.1H.967v-3.21z"
								fill={color[4]} transform="translate(0 -76.943)"/>
							<Path d="M60.232 305.414h-6.061a.484.484 0 0 1 0-.967h6.062a.484.484 0 0 1 0 .967z"
								  fill={color[4]} transform="translate(-50.475 -290.836)"/>
							<Path d="M60.232 339.018h-6.061a.484.484 0 0 1 0-.967h6.062a.484.484 0 0 1 0 .967z"
								  fill={color[4]} transform="translate(-50.475 -322.43)"/>
							<Path d="M60.232 372.621h-6.061a.484.484 0 0 1 0-.967h6.062a.484.484 0 0 1 0 .967z"
								  fill={color[4]} transform="translate(-50.475 -354.022)"/>
						</G>
					</G>
				</Svg>
			)
		},

		information: (color) => (
			<Svg viewBox="0 0 15.632 15.632">
				<G fill={color}>
					<Circle cx=".763" cy=".763" r=".763" transform="translate(7.053 10.793)"/>
					<Path
						d="M7.816 0a7.816 7.816 0 1 0 7.816 7.816A7.812 7.812 0 0 0 7.816 0zm0 14.41a6.595 6.595 0 1 1 6.594-6.594 6.591 6.591 0 0 1-6.594 6.594z"/>
					<Path
						d="M7.815 3.923a2.445 2.445 0 0 0-2.442 2.442.611.611 0 1 0 1.221 0 1.221 1.221 0 1 1 1.221 1.221.611.611 0 0 0-.611.611v1.526a.611.611 0 0 0 1.221 0V8.73a2.443 2.443 0 0 0-.611-4.808z"/>
				</G>
			</Svg>
		),
		back: (color) => (
			<Svg fill={color} viewBox="0 0 28.001 9.999">
				<Path
					d="M6.451 1.457L4.145 3.819H28v2.06H4.052l2.692 2.758L5.414 10 1.762 6.259l-.34.349L0 5.152 5.029-.003z"/>
			</Svg>
		),
		next: (color) => (
			<Svg fill={color} viewBox="0 0 12.529 20.29">
				<Path d="M18.97 31.156l7.744-7.756-7.744-7.766 2.384-2.384L31.5 23.4 21.354 33.54z"
					  transform="translate(-18.97 -13.25)" opacity={.998}/>
			</Svg>
		),

		edit: (color) => (
			<Svg viewBox="0 0 16.265 16.266">
				<Path
					d="M15.663.612c-.9-.9-2.164-.8-3.218.254l-.508.508-.829.829H.688a.678.678 0 0 0-.678.677v12.708a.678.678 0 0 0 .678.678H11.1a.678.678 0 0 0 .678-.678V7.472L14.9 4.341l.507-.507c1.056-1.055 1.156-2.319.256-3.222zm-5.245 14.3H1.365V3.557h8.39L7.892 5.423a.675.675 0 0 0-.163.263L6.713 8.715a.665.665 0 0 0 .3.8l.041.021a.68.68 0 0 0 .126.048l.032.009a.676.676 0 0 0 .145.017h.014a.673.673 0 0 0 .2-.033l2.846-.96zM10.01 7.32l-1.578.533.532-1.584 3.453-3.456.772.774.276.276zm4.441-4.445l-.028.028-.716-.717-.332-.333.029-.029c.516-.516.954-.6 1.3-.255.434.436.102.951-.253 1.306z"
					fill={color} transform="translate(-.01)"/>
				<Path d="M107.222 106.238h-1.462a.678.678 0 1 0 0 1.355h1.463a.678.678 0 1 0 0-1.355z" fill={color}
					  transform="translate(-100.632 -101.739)"/>
				<Path
					d="M55.1 257.243h-1.207v-1.207a.678.678 0 0 0-1.355 0v1.885a.678.678 0 0 0 .678.678H55.1a.678.678 0 0 0 0-1.355z"
					fill={color} transform="translate(-50.314 -244.544)"/>
			</Svg>

		),

		facebook: () => (
			<Svg viewBox="0 0 31 30">
				<Path
					d="M15.5 0A15.256 15.256 0 0 1 31 15a15.256 15.256 0 0 1-15.5 15A15.256 15.256 0 0 1 0 15 15.256 15.256 0 0 1 15.5 0z"
					fill="#1792e6"/>
				<Path
					d="M46.777 31.875h-2.771v10.15h-4.2v-10.15h-2v-3.568h2V26a3.936 3.936 0 0 1 4.235-4.236l3.11.013v3.463H44.9a.855.855 0 0 0-.89.972v2.1h3.137z"
					transform="translate(-27.119 -16.365)" fill="#fff"/>
			</Svg>

		),

		instagram: () => {
			let firstPaint = "paint" + Generator.number;
			let secondPaint = "paint" + Generator.number;

			return (
				<Svg viewBox="0 0 133 132">
					<Defs>
						<RadialGradient id={firstPaint} cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
										gradientTransform="translate(35.5385 141.001) rotate(-90) scale(128.829 119.853)">
							<Stop stopColor="#FFDD55"/>
							<Stop offset="0.1" stopColor="#FFDD55"/>
							<Stop offset="0.5" stopColor="#FF543E"/>
							<Stop offset="1" stopColor="#C837AB"/>
						</RadialGradient>
						<RadialGradient id={secondPaint} cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
										gradientTransform="translate(-20.7792 10.3642) rotate(78.6776) scale(57.5876 237.438)">
							<Stop stopColor="#3771C8"/>
							<Stop offset="0.128" stopColor="#3771C8"/>
							<Stop offset="1" stopColor="#6600FF" stopOpacity="0"/>
						</RadialGradient>
					</Defs>
					<Path
						d="M66.034 1C38.892 1 30.9541 1.028 29.4111 1.156C23.8411 1.619 20.3751 2.496 16.5991 4.376C13.6891 5.821 11.3941 7.496 9.12906 9.844C5.00406 14.126 2.50405 19.394 1.59905 25.656C1.15905 28.696 1.03105 29.316 1.00505 44.844C0.995055 50.02 1.00505 56.832 1.00505 65.969C1.00505 93.089 1.03505 101.019 1.16505 102.559C1.61505 107.979 2.46505 111.389 4.26505 115.119C7.70505 122.259 14.2751 127.619 22.0151 129.619C24.6951 130.309 27.6551 130.689 31.4551 130.869C33.0651 130.939 49.475 130.989 65.8951 130.989C82.3151 130.989 98.7351 130.969 100.305 130.889C104.705 130.682 107.26 130.339 110.085 129.609C117.875 127.599 124.325 122.319 127.835 115.079C129.6 111.439 130.495 107.899 130.9 102.762C130.988 101.642 131.025 83.785 131.025 65.952C131.025 48.116 130.985 30.292 130.897 29.172C130.487 23.952 129.592 20.442 127.77 16.732C126.275 13.695 124.615 11.427 122.205 9.108C117.904 5 112.644 2.5 106.376 1.596C103.339 1.157 102.734 1.027 87.1941 1H66.034Z"
						fill={`url(#${firstPaint})`}/>
					<Path
						d="M66.034 1C38.892 1 30.9541 1.028 29.4111 1.156C23.8411 1.619 20.3751 2.496 16.5991 4.376C13.6891 5.821 11.3941 7.496 9.12906 9.844C5.00406 14.126 2.50405 19.394 1.59905 25.656C1.15905 28.696 1.03105 29.316 1.00505 44.844C0.995055 50.02 1.00505 56.832 1.00505 65.969C1.00505 93.089 1.03505 101.019 1.16505 102.559C1.61505 107.979 2.46505 111.389 4.26505 115.119C7.70505 122.259 14.2751 127.619 22.0151 129.619C24.6951 130.309 27.6551 130.689 31.4551 130.869C33.0651 130.939 49.475 130.989 65.8951 130.989C82.3151 130.989 98.7351 130.969 100.305 130.889C104.705 130.682 107.26 130.339 110.085 129.609C117.875 127.599 124.325 122.319 127.835 115.079C129.6 111.439 130.495 107.899 130.9 102.762C130.988 101.642 131.025 83.785 131.025 65.952C131.025 48.116 130.985 30.292 130.897 29.172C130.487 23.952 129.592 20.442 127.77 16.732C126.275 13.695 124.615 11.427 122.205 9.108C117.904 5 112.644 2.5 106.376 1.596C103.339 1.157 102.734 1.027 87.1941 1H66.034Z"
						fill={`url(#${secondPaint})`}/>
					<Path
						d="M66.004 18C52.968 18 51.332 18.057 46.212 18.29C41.102 18.524 37.614 19.333 34.562 20.52C31.405 21.746 28.727 23.386 26.059 26.055C23.389 28.723 21.749 31.401 20.519 34.557C19.329 37.61 18.519 41.099 18.289 46.207C18.06 51.327 18 52.964 18 66C18 79.036 18.058 80.667 18.29 85.787C18.525 90.897 19.334 94.385 20.52 97.437C21.747 100.594 23.387 103.272 26.056 105.94C28.723 108.61 31.401 110.254 34.556 111.48C37.61 112.667 41.099 113.476 46.208 113.71C51.328 113.943 52.963 114 65.998 114C79.035 114 80.666 113.943 85.786 113.71C90.896 113.476 94.388 112.667 97.442 111.48C100.598 110.254 103.272 108.61 105.939 105.94C108.609 103.272 110.249 100.594 111.479 97.438C112.659 94.385 113.469 90.896 113.709 85.788C113.939 80.668 113.999 79.036 113.999 66C113.999 52.964 113.939 51.328 113.709 46.208C113.469 41.098 112.659 37.61 111.479 34.558C110.249 31.401 108.609 28.723 105.939 26.055C103.269 23.385 100.599 21.745 97.439 20.52C94.379 19.333 90.889 18.524 85.779 18.29C80.659 18.057 79.029 18 65.989 18H66.004ZM61.698 26.65C62.976 26.648 64.402 26.65 66.004 26.65C78.82 26.65 80.339 26.696 85.4 26.926C90.08 27.14 92.62 27.922 94.312 28.579C96.552 29.449 98.149 30.489 99.828 32.169C101.508 33.849 102.548 35.449 103.42 37.689C104.077 39.379 104.86 41.919 105.073 46.599C105.303 51.659 105.353 53.179 105.353 65.989C105.353 78.799 105.303 80.319 105.073 85.379C104.859 90.059 104.077 92.599 103.42 94.289C102.55 96.529 101.508 98.124 99.828 99.803C98.148 101.483 96.553 102.523 94.312 103.393C92.622 104.053 90.08 104.833 85.4 105.047C80.34 105.277 78.82 105.327 66.004 105.327C53.187 105.327 51.668 105.277 46.608 105.047C41.928 104.831 39.388 104.049 37.695 103.392C35.455 102.522 33.855 101.482 32.175 99.802C30.495 98.122 29.455 96.526 28.583 94.285C27.926 92.595 27.143 90.055 26.93 85.375C26.7 80.315 26.654 78.795 26.654 65.977C26.654 53.159 26.7 51.647 26.93 46.587C27.144 41.907 27.926 39.367 28.583 37.675C29.453 35.435 30.495 33.835 32.175 32.155C33.855 30.475 35.455 29.435 37.695 28.563C39.387 27.903 41.928 27.123 46.608 26.908C51.036 26.708 52.752 26.648 61.698 26.638V26.65ZM91.626 34.62C88.446 34.62 85.866 37.197 85.866 40.378C85.866 43.558 88.446 46.138 91.626 46.138C94.806 46.138 97.386 43.558 97.386 40.378C97.386 37.198 94.806 34.618 91.626 34.618V34.62ZM66.004 41.35C52.391 41.35 41.354 52.387 41.354 66C41.354 79.613 52.391 90.645 66.004 90.645C79.617 90.645 90.65 79.613 90.65 66C90.65 52.387 79.616 41.35 66.003 41.35H66.004ZM66.004 50C74.84 50 82.004 57.163 82.004 66C82.004 74.836 74.84 82 66.004 82C57.167 82 50.004 74.836 50.004 66C50.004 57.163 57.167 50 66.004 50V50Z"
						fill="white"/>
				</Svg>
			)
		},

		youtube: () => (
			<Svg viewBox="0 0 31.188 30">
				<Path
					d="M15.594 0c8.612 0 15.594 6.716 15.594 15s-6.981 15-15.594 15S0 23.284 0 15 6.982 0 15.594 0z"
					fill="#cd081e"/>
				<Path d="M91.431 69.38a14.434 14.434 0 0 1 0 21.07 16.116 16.116 0 0 1-22.055 0z" fill="#cd081e"
					  transform="translate(-64.811 -64.814)"/>
				<Path
					d="M152.222 174.866l-7.718-7.718-9.1 1.036-5.506 8.524L140.183 187a15.612 15.612 0 0 0 12.039-12.134z"
					transform="translate(-121.347 -157.337)" fill="#a20f1f"/>
				<Path
					d="M136.261 157.639a2.366 2.366 0 0 0-2.366-2.367H122.8a2.366 2.366 0 0 0-2.365 2.367v6.347a2.366 2.366 0 0 0 2.365 2.367h11.1a2.366 2.366 0 0 0 2.366-2.367v-6.347zm-9.5 5.851v-5.961l4.521 2.981z"
					transform="translate(-112.507 -145.658)" fill="#fff"/>
			</Svg>
		),

		twitter: () => (
			<Svg viewBox="0 0 512 512">
				<Circle cx="256" cy="256" fill="#55ACEE" r="238.2"/>
				<Path
					d="M116.3,344.2c31.3,3,59-4.9,84.3-23.8     c-6.6-0.5-12.3-1.4-17.8-3.4c-14.5-5.2-25.3-14.6-32.2-28.2c-1-1.9-1.8-4-2.7-6c-1-2,0-2.4,1.8-2c7.2,1.1,14.2,0.7,21.3-0.8     c0.1,0,0.2-0.2,0.5-0.3c0.1-0.8-0.5-0.9-1-1c-15.9-4-27.9-13.3-36.1-27.4c-4.7-8-7.1-16.6-7.3-25.8c0-2.4,0.6-2.6,2.6-1.7     c7.1,3.4,14.5,5.5,23,5.8c-4.1-3.3-7.9-6.3-10.9-9.9c-11.3-13.3-15.9-28.6-13.7-45.9c0.8-6.5,2.8-12.4,5.7-18.3     c1-2.2,1.8-2.4,3.4-0.5c9.2,11.2,19.9,20.7,31.8,29c8.9,6.3,18.3,11.4,28.2,15.7c12.9,5.6,26.2,9.3,40,11.6     c4.7,0.7,9.3,0.9,13.9,1.5c2.2,0.2,2.5-0.6,2-2.5c-2.3-12-0.8-23.7,4.4-34.6c8.2-17.1,21.6-28,40.3-32     c18.4-3.9,34.8,0.7,49.4,12.4c4.7,7.1,10.6,3,15.9,1.5c8.5-2.4,16.5-6,24.4-10.2c-4,12.9-12,22.7-23,30.4     c10.7-0.7,20.6-4,31.2-8.2c-2.8,4.4-5.7,8-8.5,11.4c-5.4,6.4-11.5,11.8-18.1,16.9c-1.4,1-1.7,2-1.7,3.6     c0.3,11.6-0.6,23.1-2.7,34.5c-2.2,12-5.7,23.5-10.4,34.6c-5.2,12.4-11.8,24.3-19.9,35.1c-10,13.5-21.9,25.4-35.6,35.2     c-18.6,13.2-39.2,21.9-61.5,26.1c-14,2.7-28.1,3.5-42.5,2.8c-11-0.6-21.9-2.3-32.6-5c-13.3-3.4-26.1-8.5-38-15.4     C121.7,347.8,118.8,346.7,116.3,344.2z"
					fill="none" stroke="#FAFAFA" strokeMiterlimit="10" strokeWidth="10"/>
			</Svg>
		),

		logout: () => (
			<svg viewBox="0 0 17.015 17.888">
				<Path
					d="M8.479 17.248H2.12a.727.727 0 0 1-.707-.745V3.086a.727.727 0 0 1 .707-.745h6.359a.726.726 0 0 0 .707-.741.726.726 0 0 0-.707-.75H2.12A2.183 2.183 0 0 0 0 3.086V16.5a2.183 2.183 0 0 0 2.12 2.236h6.359a.746.746 0 0 0 0-1.491z"
					fill={"#fff"} transform="translate(0 -.85)"/>
				<Path
					d="M181.252 111.608l-4.3-4.24a.707.707 0 1 0-.992 1.006l3.07 3.03h-8.227a.707.707 0 1 0 0 1.413h8.227l-3.07 3.03a.706.706 0 1 0 .992 1.006l4.3-4.24a.706.706 0 0 0 0-1.006z"
					fill={"#fff"} transform="translate(-164.447 -103.167)"/>
			</svg>
		),

		chevron: (color) => (
			<Svg viewBox="0 0 7.328 13.111" fill={color}>
				<Path
					d="M162.217 94.641l4.85-4.957a.948.948 0 0 0 0-1.323.906.906 0 0 0-1.3 0l-5.5 5.617a.951.951 0 0 0-.027 1.292l5.518 5.656a.907.907 0 0 0 1.3 0 .948.948 0 0 0 0-1.323z"
					transform="rotate(180 9.416 16.174) translate(-148.503 -68.851)"/>
			</Svg>
		),

		renewOrder: (color) => (
			<Svg viewBox="0 0 18.779 23.006" fill={color}>
				<G transform="translate(-47.031)">
					<G transform="translate(49.336 3.458)">
						<Path
							d="M101,78.113a.36.36,0,0,0-.36.36.792.792,0,1,1-.792-.792.36.36,0,1,0,0-.72,1.513,1.513,0,1,0,1.513,1.513A.36.36,0,0,0,101,78.113Z"
							transform="translate(-98.338 -76.96)"/>
					</G>
					<G transform="translate(49.336 7.684)">
						<Path
							d="M101,172.175a.36.36,0,0,0-.36.36.792.792,0,1,1-.792-.792.36.36,0,0,0,0-.72,1.513,1.513,0,1,0,1.513,1.513A.36.36,0,0,0,101,172.175Z"
							transform="translate(-98.338 -171.022)"/>
					</G>
					<G transform="translate(53.179 9.606)">
						<G>
							<Path d="M186.9,213.779h-2.69a.36.36,0,1,0,0,.72h2.69a.36.36,0,1,0,0-.72Z"
								  transform="translate(-183.849 -213.779)"/>
						</G>
					</G>
					<G transform="translate(53.179 8.069)">
						<G>
							<Path d="M186.9,179.574h-2.69a.36.36,0,1,0,0,.72h2.69a.36.36,0,1,0,0-.72Z"
								  transform="translate(-183.849 -179.574)"/>
						</G>
					</G>
					<G transform="translate(53.179 13.832)">
						<G>
							<Path d="M186.13,307.841h-1.921a.36.36,0,0,0,0,.72h1.921a.36.36,0,0,0,0-.72Z"
								  transform="translate(-183.849 -307.841)"/>
						</G>
					</G>
					<G transform="translate(53.179 12.295)">
						<G>
							<Path d="M186.9,273.637h-2.69a.36.36,0,1,0,0,.72h2.69a.36.36,0,1,0,0-.72Z"
								  transform="translate(-183.849 -273.637)"/>
						</G>
					</G>
					<G transform="translate(53.179 5.379)">
						<G>
							<Path d="M190.357,119.716h-6.148a.36.36,0,1,0,0,.72h6.148a.36.36,0,0,0,0-.72Z"
								  transform="translate(-183.849 -119.716)"/>
						</G>
					</G>
					<G transform="translate(53.179 3.842)">
						<G>
							<Path d="M188.82,85.511h-4.611a.36.36,0,1,0,0,.72h4.611a.36.36,0,1,0,0-.72Z"
								  transform="translate(-183.849 -85.511)"/>
						</G>
					</G>
					<G transform="translate(49.336 11.911)">
						<Path
							d="M101,266.238a.36.36,0,0,0-.36.36.792.792,0,1,1-.792-.792.36.36,0,1,0,0-.72,1.513,1.513,0,1,0,1.513,1.513A.36.36,0,0,0,101,266.238Z"
							transform="translate(-98.338 -265.085)"/>
					</G>
					<G transform="translate(47.031)">
						<Path
							d="M61.223,0H48.16a1.13,1.13,0,0,0-1.129,1.129V17.266a1.13,1.13,0,0,0,1.129,1.129h6.532a.36.36,0,0,0,0-.72H48.16a.409.409,0,0,1-.408-.408V1.129A.409.409,0,0,1,48.16.72H61.223a.409.409,0,0,1,.408.408V13.04a.36.36,0,1,0,.72,0V1.129A1.13,1.13,0,0,0,61.223,0Z"
							transform="translate(-47.031)"/>
					</G>
					<G transform="translate(55.677 8.069)">
						<G>
							<Path
								d="M248.4,186.116a1.329,1.329,0,0,0-.934.263,1.312,1.312,0,0,0-.987-.647,1.329,1.329,0,0,0-.934.263,1.312,1.312,0,0,0-.987-.647,1.331,1.331,0,0,0-.735.138V180.9a1.321,1.321,0,0,0-1.456-1.314,1.363,1.363,0,0,0-1.186,1.369v4.6l-1.059,1.059a2.267,2.267,0,0,0-.608,2.136l.8,3.417a3.038,3.038,0,0,0,2.969,2.351h3.249a3.053,3.053,0,0,0,3.05-3.05v-3.98A1.363,1.363,0,0,0,248.4,186.116Zm.465,5.348a2.332,2.332,0,0,1-2.329,2.329h-3.249a2.32,2.32,0,0,1-2.267-1.8l-.8-3.417a1.551,1.551,0,0,1,.416-1.461l.549-.549v1.244a.36.36,0,0,0,.72,0v-6.861a.637.637,0,0,1,.537-.652.6.6,0,0,1,.664.6v6.34a.36.36,0,1,0,.72,0v-.576a.6.6,0,0,1,.664-.6.637.637,0,0,1,.537.652v.906a.36.36,0,1,0,.72,0v-.576a.6.6,0,0,1,.664-.6.637.637,0,0,1,.537.652v.906a.36.36,0,0,0,.72,0v-.576a.6.6,0,0,1,.664-.6.637.637,0,0,1,.537.652v3.98Z"
								transform="translate(-239.452 -179.578)"/>
						</G>
					</G>
				</G>
			</Svg>


		)
	};
}
